(() => {
  const checkboxFor = (form) => Array.from(document.querySelectorAll('[data-secret-consent]')).find(input => input.form === form);
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-secret-consent]')) return;
    event.stopImmediatePropagation();
    const container = event.target.closest('.secret-consent');
    container.querySelector('[data-secret-consent-time]').value = event.target.checked ? new Date().toISOString() : '';
  }, true);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="checkout"]');
    if (!button) return;
    const input = checkboxFor(button.form);
    if (input && !input.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.focus();
      input.reportValidity();
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const input = checkboxFor(event.target);
    if (input && !input.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.focus();
      input.reportValidity();
    }
  }, true);
})();